/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { DateTimeDTO } from '../model/models';
import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface DataEOraServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Restituisce il timestamp riportante la data e l\&#39;ora corrente del server nel formato yyyy-MM-dd\&#39;T\&#39;HH:mm:ss.SSSSSSS.
     * Endpoint di utilità che restituisce il timestamp UTC corrente del server. Utile per sincronizzare l\&#39;ora del client con quella del server.
     * @endpoint get /api/v1/now
*/
    getTimestampNow(extraHttpRequestParams?: any): Observable<DateTimeDTO>;

}
